import React, { Component, useEffect, useState } from "react";

import {
  Row,
  Col,
  Input,
  Button,
  Alert,
  Container,
  Label,
  FormGroup,
} from "reactstrap";
import { useHistory } from "react-router-dom";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import toastr from "toastr";
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// actions
import { checkLogin, apiError } from "../../store/actions";
import usePost from "../../helpers/hooks/usePost";
// import images
import logodark from "../../assets/images/logo-dark.png";
import useGet from "../../helpers/hooks/useGet";

function Login() {
  const [isChecked, setIsChecked] = useState("ADMIN");
  const [isBool, setIsBool] = useState(false);
  const [userId, setUserId] = useState("");
  const history = useHistory();
  const [postLogin, postedData, postingError, dataPosting] =
    // usePost("login");
    usePost("users/login");
  const [bankLogin, bankData, bankError, bankLoading] = usePost(
    "login",
    "loan"
  );
  const [token, tokenError, tokenLoading, callToken] = useGet(
    `get_token?user_id=${userId}`,
    isBool,
    "loan"
  );
  // console.log({postedData, token})
  const handleSubmit = (event, values) => {
    console.log(values);
    if (isChecked === "BANKADMIN") {
      bankLogin({
        email: values.email,
        password: values.password,
        type: isChecked,
      });
    } else {
      postLogin({
        email: values.email,
        password: values.password,
        type: isChecked,
      });
    }
  };
  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const loanAuth = JSON.parse(localStorage.getItem("loanAuth"));
      const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));

      console.log(
        `🚀 ~ file: Login.js ~ line 42 ~ useEffect ~ authUser`,
        authUser,
        bankAdmin
      );

      if (bankAdmin?.bank_admin_authenticated) {
        console.log("bankadmin", isChecked);
        history.push("/loan-list");
      }

      if (authUser?.authenticated && loanAuth?.loan_authenticated) {
        history.push("/loan");
      }
    } catch (error) {}
    document.body.classList.add("auth-body-bg");
    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, [history]);
  useEffect(() => {
    if (postedData) {
      localStorage.setItem(
        "authUser",
        JSON.stringify({ authenticated: true, data: postedData })
      );
      setUserId(postedData?.user?.id);
      console.log(postedData?.user?.id);
      // history.push("/baythak");
    }
    if (bankData) {
      localStorage.setItem(
        "bankAdmin",
        JSON.stringify({
          bank_admin_authenticated: true,
          data: bankData,
          type: "BA",
        })
      );
      console.log("bank login");
      history.push("/loan-list");
    }
  }, [history, postedData, bankData]);

  useEffect(() => {
    if (userId) {
      setIsBool(true);
      callToken();
      console.log(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (token) {
      console.log({ token });
      localStorage.setItem(
        "loanAuth",
        JSON.stringify({ loan_authenticated: true, token })
      );
      history.push("/loan");
    }
    if (tokenError) {
      console.log({ tokenError });
    }
  }, [token, history, tokenError]);
  return (
    <>
      <div>
        <Row className="no-gutters">
          <Col lg={4}>
            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div className="w-100">
                <Row className="justify-content-center">
                  <Col lg={9}>
                    <div>
                      <div className="text-center">
                        <div>
                          <Link to="/" className="logo">
                            <img src={logodark} height="40" alt="logo" />
                          </Link>{" "}
                        </div>
                        <h4 className="font-size-18 mt-4">
                          Sign in to continue.{" "}
                        </h4>{" "}
                        {/* <p className='text-muted'>
                                                  Sign in to continue.
                                                </p> */}{" "}
                      </div>
                      {postingError || bankError ? (
                        <Alert color="danger">
                          {" "}
                          Invalid email or password{" "}
                        </Alert>
                      ) : null}
                      <div className="p-2 mt-5">
                        <AvForm
                          className="form-horizontal"
                          onValidSubmit={handleSubmit}
                        >
                          <FormGroup className="auth-form-group-custom mb-4">
                            <i className="ri-user-2-line auti-custom-input-icon">
                              {" "}
                            </i>{" "}
                            <Label htmlFor="email"> Email </Label>{" "}
                            <AvField
                              name="email"
                              type="text"
                              className="form-control"
                              id="email"
                              validate={{ email: true, required: true }}
                              placeholder="Enter email"
                            />
                          </FormGroup>
                          <FormGroup className="auth-form-group-custom mb-4">
                            <i className="ri-lock-2-line auti-custom-input-icon">
                              {" "}
                            </i>{" "}
                            <Label htmlFor="userpassword"> Password </Label>{" "}
                            <AvField
                              name="password"
                              type="password"
                              className="form-control"
                              id="userpassword"
                              placeholder="Enter password"
                            />
                          </FormGroup>
                          <FormGroup tag="fieldset">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="radio1"
                                  checked={isChecked === "ADMIN"}
                                  onChange={() => setIsChecked("ADMIN")}
                                />{" "}
                                Administrator
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="radio1"
                                  checked={isChecked === "CCR"}
                                  onChange={() => setIsChecked("CCR")}
                                />{" "}
                                Customer Care Representative
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name="radio1"
                                  checked={isChecked === "BANKADMIN"}
                                  onChange={() => setIsChecked("BANKADMIN")}
                                />{" "}
                                Bank Administrator
                              </Label>
                            </FormGroup>
                          </FormGroup>
                          {/* <div className='custom-control custom-checkbox'>
                                                                        <Input
                                                                          type='checkbox'
                                                                          className='custom-control-input'
                                                                          id='customControlInline'
                                                                        />
                                                                        <Label
                                                                          className='custom-control-label'
                                                                          htmlFor='customControlInline'
                                                                        >
                                                                          Remember me
                                                                        </Label>
                                                                      </div> */}
                          <div className="mt-4 text-center">
                            <Button
                              color="primary"
                              className="w-md waves-effect waves-light"
                              type="submit"
                              disabled={dataPosting || bankLoading}
                            >
                              {dataPosting || bankLoading
                                ? "Loging in..."
                                : "Log In"}{" "}
                            </Button>{" "}
                          </div>
                          {/* <div className='mt-4 text-center'>
                                                                            <Link
                                                                              to='/forgot-password'
                                                                              className='text-muted'
                                                                            >
                                                                              <i className='mdi mdi-lock mr-1'></i> Forgot
                                                                              your password?
                                                                            </Link>
                                                                          </div> */}{" "}
                        </AvForm>{" "}
                      </div>
                      {/* <div className='mt-5 text-center'>
                                                                        <p>
                                                                          Don't have an account ?{' '}
                                                                          <Link
                                                                            to='/register'
                                                                            className='font-weight-medium text-primary'
                                                                          >
                                                                            {' '}
                                                                            Register{' '}
                                                                          </Link>{' '}
                                                                        </p>
                                                                        <p>
                                                                          © 2020 Beythak. Crafted with{' '}
                                                                          <i className='mdi mdi-heart text-danger'></i> by
                                                                          Themesdesign
                                                                        </p>
                                                                      </div> */}{" "}
                    </div>{" "}
                  </Col>{" "}
                </Row>{" "}
              </div>{" "}
            </div>{" "}
          </Col>{" "}
          <Col lg={8}>
            <div className="authentication-bg">
              <div className="bg-overlay"> </div>{" "}
            </div>{" "}
          </Col>{" "}
        </Row>{" "}
      </div>{" "}
    </>
  );
}
export default Login;
